export function loadErrorImage(event : any, width: string, height: string) {
  event.target.src = `/i/Parts/image-coming-soon.jpg?width=${width}&height=${height}`
}

export const COMING_SOON_IMG_PATH = '/i/Parts/image-coming-soon.jpg'
